import { chiliPayUserApi, type PutUserMePayload } from '@capsicum/common';
import { useMutation } from '@tanstack/react-query';

export const UseUpdateUserDetailsQueryKey = ['update-user'];

export const useUpdateUserDetails = () => {
	const { data, error, isError, isPending, isSuccess, mutateAsync } = useMutation({
		mutationFn: async (queryParams: PutUserMePayload) => (await chiliPayUserApi).putUserMe(queryParams),
		mutationKey: UseUpdateUserDetailsQueryKey
	});

	return {
		data,
		error,
		isError,
		isLoading: isPending,
		isSuccess,
		mutateAsync
	};
};
